"use strict";const e=require("react/jsx-runtime"),n=require("react"),s=require("./GenericButton.js"),o=t=>e.jsx(s,{useAsLink:!0,...t}),r=n.memo(o);module.exports=r;
//# sourceMappingURL=LinkButton.js.map
